<template>
  <v-dialog v-model="innerShowValue" scrollable persistent width="350">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-2">mdi-information</v-icon>
        Informasi
        <v-btn class="mt-n1" icon dark top right absolute @click="handleClose">
          <v-icon color="grey">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6">
        <p class="ma-0 body-1">
          Apakah anda yakin menghapus Wilayah
          <span class="font-weight-bold">
            {{ detail.name }}
          </span>
          ?
        </p>
        <v-alert
          v-if="errorMessage"
          text
          type="error"
          class="custom-alert my-4"
        >
          <p class="body-2 mb-0">
            {{ errorMessage }}
          </p>
        </v-alert>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer></v-spacer>
        <v-btn
          small
          color="red"
          text
          elevation="0"
          :disabled="status === 'pending'"
          class="text-capitalize"
          @click="handleDelete"
        >
          Hapus
        </v-btn>
        <v-btn
          small
          light
          color="light-green"
          elevation="0"
          :disabled="status === 'pending'"
          @click="handleClose"
          class="white--text text-capitalize"
        >
          Tidak
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      innerShowValue: false,
      status: 'idle',
      errorMessage: ''
    };
  },

  watch: {
    value(val) {
      this.innerShowValue = val;
    },

    innerShowValue(val) {
      this.$emit('input', val);
    }
  },

  mounted() {
    this.innerShowValue = this.value;
  },

  methods: {
    handleClose() {
      this.innerShowValue = false;
    },

    async handleDelete() {
      this.status = 'pending';
      try {
        await axios.delete(
          `https://api-v2-monsta-mls.monsta.id/api/units/${this.detail.id}`,

          {
            headers: {
              Authorization:
                'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
            }
          }
        );
        this.$emit('deleted');
        this.innerShowValue = false;
        this.status = 'resolved';
      } catch (error) {
        this.errorMessage = error.response.data.message;
        this.status = 'rejected';
      }
    }
  }
};
</script>
